const VueCan = {
  install(Vue) {
    Vue.prototype.$can = (routes) => {
      if (typeof routes === 'string') routes = [routes];

      // TODO: fix roles
      let some = true;

      routes.forEach((route) => {
        const roles = Vue.router.matcher.match(route).meta.auth;
        if (Vue.auth.check(roles)) some = true;
      });

      return some;
    };
  },
};

export default VueCan;
